import { render, staticRenderFns } from "./ServicosApi.vue?vue&type=template&id=1bbfbe14&scoped=true&"
import script from "./ServicosApi.vue?vue&type=script&lang=js&"
export * from "./ServicosApi.vue?vue&type=script&lang=js&"
import style0 from "./ServicosApi.vue?vue&type=style&index=0&id=1bbfbe14&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbfbe14",
  null
  
)

export default component.exports